import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Dialog, DialogBody } from '../../common/components/Modal/Modal';
import { SlotForm } from '../components/SlotForm';
import { PrefillSlot } from '../models/valueObjects/PrefillSlot';
import { SlotService } from '../services/SlotService';

type Props = {
  slot: PrefillSlot;
  onClosed: (slotId: number | undefined) => void;
};

export const UpdateSlotFlow = ({ slot, onClosed }: Props) => {
  // It's not a preference to have services in states, but we use it here so
  // that we can leverage same service in multiple functionalities.
  const [slotService] = useState<SlotService>(new SlotService());

  useEffect(() => {
    return () => {
      slotService.cancelAllRequests();
    };
  }, [slotService]);

  return (
    <Dialog title={t('updateSlot.title')} subtitle={t('updateSlot.subtitle')} onDismiss={() => onClosed(undefined)}>
      <DialogBody>
        <SlotForm
          prefill={{
            name: slot.getName(),
            description: slot.getDescription(),
            slotType: slot.getSlotType(),
            tags: slot.getTags(),
          }}
          submit={{
            label: t('updateSlot.submit'),
            action: (name, description, _, tags) => slotService.updateSlot(slot.getId(), name, description, tags).then((s) => onClosed(s.getId())),
          }}
          back={{ label: t('updateSlot.back'), action: () => onClosed(undefined) }}
        />
      </DialogBody>
    </Dialog>
  );
};
